import { useState } from 'react';
import './CoverArt.scss';
import ImagePreviewModal from '../../ImagePreviewModal/ImagePreviewModal';
import { IImageAsset } from '@/data/models/album';
import { useTranslation } from 'react-i18next';
import PrsImage from '@/components/common/PrsImage/PrsImage';
import { SignedUrl } from '@/data/models/signedUrl';

interface CoverArtProps {
  asset: IImageAsset | null | undefined;
  albumId: string | undefined;
  signedUrl: SignedUrl | undefined;
  readonly: boolean;
  downloadAsset: () => void;
  removeAsset: () => void;
}

export default function CoverArt({
  asset,
  albumId,
  signedUrl,
  readonly,
  downloadAsset,
  removeAsset,
}: CoverArtProps) {
  const [showImagePreviewModal, setShowImagePreviewModal] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="product-thumbnail">
      <ImagePreviewModal
        asset={asset}
        albumId={albumId}
        show={showImagePreviewModal}
        onClose={() => setShowImagePreviewModal(false)}
      ></ImagePreviewModal>
      {signedUrl?.url ? (
        <div>
          <PrsImage
            signedUrl={signedUrl}
            alt={t('product.coverArt')}
          ></PrsImage>
          <div
            className="overlay"
            onClick={() => setShowImagePreviewModal(true)}
          >
            <div id="imagePreviewIcon">
              <i
                className="icon far fa-search-plus"
                title={t('upload.image_zoom_in')}
              ></i>
            </div>

            <div className="image-buttons">
              <button
                type="button"
                className="icon-btn download-button"
                title={t('common.generic.download')}
                onClick={(e) => {
                  e.stopPropagation();
                  downloadAsset();
                }}
              >
                <i className="icon fas fa-arrow-alt-to-bottom"></i>
              </button>

              {!readonly ? (
                <button
                  type="button"
                  className="icon-btn delete-button"
                  title={t('upload.remove_asset')}
                  onClick={(e) => {
                    removeAsset();
                    e.stopPropagation();
                  }}
                >
                  <i className="icon fas fa-trash"></i>
                </button>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
